<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
    :width="$vuetify.breakpoint.mdAndDown ? null : 1300"
  >
    <div class="d-grid grid-col-1-1-1 gap-5 align-start">
      <div class="d-flex flex-column gap5">
        <BaseInput
          :label="t['dialog-add_edit-labels']['nazvanie-kompanii']"
          v-model="data.name"
          :viewValue="data.name || '-'"
          :rules="['required', 'max100']"
        />
        <div class="d-flex align-center gap5">
          <v-avatar size="50" color="#f2f2f2">
            <v-img v-if="data.logo" :src="apiDomain + '/min/' + data.logo" contain/>
          </v-avatar>
          <UploadFile
            :tooltip="t['dialog-add_edit-buttons'][data.logo ? 'izmenit-logotip' : 'zagruzit-logotip']"
            :accept="['jpg', 'jpeg', 'png']"
            :on-load="onLoadLogo"
            :multiple="false"
            :minimal="false"
          />
        </div>
        <BaseInput
          v-for="field in fields[0]"
          :key="field.name"
          :label="field.label"
          v-model="data[field.name]"
          :rules="field.rules"
        />
      </div>
      <div>
        <GoogleAutocomplete
          v-for="field in fields[2]"
          :key="key + '_' + field.name + data[field.name + 'street'] + data[field.name + 'zip'] + data[field.name + 'city']"
          :title="field.label"
          :street="data[field.name + 'street']"
          :zip="data[field.name + 'zip']"
          :city="data[field.name + 'city']"
          :external-data="{field: field.name}"
          :on-change="changeAddress"
        />
      </div>
      <BaseCard flat :subtitle="t['dialog-add_edit']['elektronnyy-schet-faktura']">
        <BaseInput
          v-for="field in fields[1]"
          :key="field.name"
          :label="field.label"
          v-model="data[field.name]"
          :rules="field.rules"
        />
      </BaseCard>
    </div>
  </TemplateModal>
</template>

<script>
import UploadFile from "components/UploadFile";
import {mapActions, mapGetters} from "vuex";
import BaseCard from "components/base/BaseCard";
import GoogleAutocomplete from "components/google/autocomplete/GoogleAutocomplete";

export default {
  name: 'WorkClientMainModal',
  components: {GoogleAutocomplete, BaseCard, UploadFile},
  props: {
    id: {
      type: [Number, String],
      default: -1
    },
    create: {
      type: Boolean,
      default: false
    },
    minimalize: {
      type: Boolean,
      default: false
    },
    companySale: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    dialog: false,
    data: {},
    key: 0,
  }),
  computed: {
    ...mapGetters(['apiDomain']),
    t() {
      return this.localStorage.translations.pages['setting-client']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit'][this.companySale ? 'create-company-sale' : 'sozdanie-klienta'],
        },
        title: {
          create: this.t['dialog-add_edit'][this.companySale ? 'create-company-sale' : 'sozdanie-klienta'],
        }
      }
    },
    params() {
      return {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        id: this.$route.params.id,
      }
    },
    fields() {
      return [
        [
          {label: this.t['tables']['vat'], name: 'vat', rules: ['required', 'max20']},
          {label: this.t['tables']['y-tunnus'], name: 'ytunnus', rules: ['required', 'size9']},
        ],
        [
          {label: this.t['tables']['adres-elektronnoy-nakladnoy-ovt'], name: 'ovt', rules: ['required', 'max20']},
          {label: this.t['tables']['id-operatora'], name: 'operator_id', rules: ['required', 'max20']},
          {label: this.t['tables']['operator'], name: 'operator', rules: ['required', 'max50']},
        ],
        [
          {label: this.t['dialog-adress']['adres-dlya-vystavleniya-schetov'], name: this.companySale ? '' : 'billing_'},
        ]
      ]
    },
  },
  watch: {},
  methods: {
    ...mapActions('workClient', ['onWorkClientCreate', 'onWorkClientAll']),
    ...mapActions('workClientInvoicingCompany',
      ['onWorkClientInvoicingCompanyCreate', 'onWorkClientInvoicingCompanyAll']),
    async onOpen() {
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.companySale) {
        await this.onWorkClientInvoicingCompanyCreate(this.data)
          .then(() => {
            this.onWorkClientInvoicingCompanyAll()
          })
      } else {
        await this.onWorkClientCreate(this.data)
          .then(() => {
            this.onWorkClientAll()
          })
      }
    },
    onLoadLogo(data) {
      this.data.logo = data[0].url
      this.key++
    },
    changeAddress(data) {
      let field = data.externalData.field
      this.data[field + 'street'] = data.street
      this.data[field + 'zip'] = data.zip
      this.data[field + 'city'] = data.city
      // this.key++
    }
  },
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    grid-template-columns: 1fr;
  }
}
</style>
